import { render, staticRenderFns } from "./IntegrationDetailsForm.vue?vue&type=template&id=c8c1c108"
import script from "./IntegrationDetailsForm.vue?vue&type=script&lang=js"
export * from "./IntegrationDetailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports